import Skeleton from 'components/3catinfo/Skeleton/Skeleton';
import styles from './destacatDirecte.module.scss';

const DestacatDirecteSkeleton = (props) => {
    return (
        <div className={styles.itemDirecte}>
            <div className={styles.wrapperItemDirecte}>
                <div className={styles.imatge}>
                    <Skeleton imatge />
                </div>
                <Skeleton linia borderRadius={2} className={styles.progres} />

                <div className={styles.descripcio}>
                    <div>
                        <Skeleton titol className={styles.titol} />
                        <Skeleton text className={styles.capitol} num={3} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DestacatDirecteSkeleton;
